import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { IconButton } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import { districts } from '../user/Districs';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import MenuDriver from "./MenuDriver";
import MarkerTextDriver from './MarkerTextDriver';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';


function MapDriver({ setActiveComponent, handleEntregasClick, handleRecojosClick, userId, onBackClick, setMainDeliveryPoints, setMainOrder}) {
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const [user, setUser] = useState(null);
  const [deliveryPoints, setDeliveryPoints] = useState([]);
  const [deliveryPointsMarkers, setDeliveryPointsMarkers] = useState([]);
  const [orderPoints, setOrderPoints] = useState([]);
  const [orderPointsMarkers, setOrderPointsMarkers] = useState([]);
  const [userMarker, setUserMarker] = useState(null);
  const [driver, setDriver] = useState(null);
  // const [currentLocationMarker, setCurrentLocationMarker] = useState(null);
  
  const [driverMarker, setDriverMarker] = useState([]);
  // const [showMarkers, setShowMarkers] = useState(false);
  
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [sequence, setSequence] = useState(0);
  const [updatedPoints, setUpdatedPoints] = useState([]);
  const [updatedOrders, setUpdatedOrders] = useState([]);
  const [showTextField, setShowTextField] = useState(false);
  const [selectedMapDeliveryPoint, setSelectedMapDeliveryPoint] = useState(null);
  const [showDeliveryPoint, setShowDeliveryPoint] = useState(false);
  const [selectedMapOrder, setSelectedMapOrder] = useState(null);
  const [showOrder, setShowOrder] = useState(false);
  


  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/driver/${userId}`)
      .then(response => {
        setUser(response.data);
        console.log('user ', response.data);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, [userId]);

  useEffect(() => {
      if (!user || !userId) return;           // guard

      const POLL_MS = 5000;
      let timer;
      let inFlight = false;
      let stopped = false;
      const ctrl = new AbortController();      // cancels both requests in a tick

      const tick = async () => {
        if (stopped || inFlight) return;       // no overlap
        inFlight = true;

        try {
          const [dpRes, ordRes] = await Promise.allSettled([
            axios.get(
              `${process.env.REACT_APP_API_URL}/api/delivery_points/driver/${userId}`,
              { signal: ctrl.signal }
            ),
            axios.get(
              `${process.env.REACT_APP_API_URL}/api/delivery_orders/driver/${userId}`,
              { signal: ctrl.signal }
            )
          ]);

          if (!stopped) {
            if (dpRes.status === 'fulfilled') {
              setDeliveryPoints(dpRes.value.data);
              // console.log('delivery points', dpRes.value.data);
            } else if (!(dpRes.reason?.name === 'CanceledError' || dpRes.reason?.code === 'ERR_CANCELED')) {
              console.error('Error fetching delivery points:', dpRes.reason);
            }

            if (ordRes.status === 'fulfilled') {
              setOrderPoints(ordRes.value.data);
              // console.log('order points', ordRes.value.data);
            } else if (!(ordRes.reason?.name === 'CanceledError' || ordRes.reason?.code === 'ERR_CANCELED')) {
              console.error('Error fetching order points:', ordRes.reason);
            }
          }
        } finally {
          inFlight = false;
          if (!stopped) timer = setTimeout(tick, POLL_MS); // schedule next AFTER finish
        }
      };

      // initial fetch
      tick();

      // cleanup on unmount or when userId changes
      return () => {
        stopped = true;
        ctrl.abort();            // cancels any in-flight axios.get
        clearTimeout(timer);     // stops future ticks
      };
    }, [user]);

  useEffect(() => {
    if (mapRef.current) {
        initializeDeliveryMarkers();
        initializeOrderMarkers();
    }
  }, [deliveryPoints, orderPoints]);


  useEffect(() => {
    if (mapContainerRef.current && !mapRef.current) {
      // Initialize Leaflet map (Leaflet expects [lat, lng])
      mapRef.current = L.map(mapContainerRef.current, {
        center: [-12.060235303763926, -77.03711992646711], // Default coordinates (Lima)
        zoom: 15,
        zoomControl: false,
      });
      // Add an OSM tile layer (you can change this if needed)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(mapRef.current);
  
      // Optional: When the map finishes loading, perform additional initialization.
      mapRef.current.on('load', () => {
        // initializeUserMarker();
        // fitMapToMarkers();
      });
    } else if (mapRef.current) {
      // If the map already exists, update markers as needed.
      // initializeUserMarker();
      // initializeDeliveryMarkers();
      // initializeOrderMarkers();
      // fitMapToMarkers();
    }
  }, []);

  

  const initializeDeliveryMarkers = () => {
    // Remove existing markers
    deliveryPointsMarkers.forEach(marker => marker.remove());
  
    const newMarkers = deliveryPoints
      .filter(point => point.latitude && point.longitude) // Only points with valid coordinates
      .map(point => {
        let color = 'blue'; // Default color for delivery points
  
        // Adjust color based on status
        switch (point.status) {
          case 'pending':
            switch (point.slot) {
              case 1:
                color = '#BF360C';  // most urgent
                break;
              case 2:
                color = '#E65100';
                break;
              case 3:
                color = '#F57C00';
                break;
              case 4:
                color = '#FFB74D';
                break;
              case 5:
                color = '#FFE0B2';  // least urgent
                break;
              default:
                color = 'gray';  // fallback
            }
            break;
          case 'recogido':
            color = 'purple';
            break;
          case 'entregado':
            color = 'green';
            break;
          case 'cancelado':
            color = 'red';
            break;
          case 'encamino':
            color = 'blue';
            break;
          default:
            color = 'gray';
        }
  
        // Create a custom Leaflet divIcon for the marker
        const icon = L.divIcon({
          html: `<div style="
            background-color: ${color};
            width: 24px;
            height: 24px;
            border: 1px solid black;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            color: white;
          ">${point.sequence ? point.sequence : ''}</div>`,
          className: '', // Remove default styling
          iconSize: [24, 24],
          iconAnchor: [12, 12], // Center the icon on the coordinate
        });
  
        // Create and add the marker
        const marker = L.marker([point.latitude, point.longitude], {
          icon,
          title: 'Delivery Location',
        })
          .on('click', () => {
            if (point.status === 'encamino') {
              setSelectedPoint(point);
            } else if (point.status === 'pending' && !point.customer_id) {
              handleSequenceChange(point);
            } else if (point.status === 'entregado') {
              setSelectedPoint(point);
            } else if (point.status === 'pending' && point.customer_id) {
              handleOrderSequenceChange(point);
            }
          })
          .addTo(mapRef.current);
  
        return marker;
      });
  
    setDeliveryPointsMarkers(newMarkers);
  };
  

  const initializeOrderMarkers = () => {
    // Remove existing markers
    orderPointsMarkers.forEach(marker => marker.remove());
  
    const newMarkers = orderPoints.map(point => {
      let { latitude, longitude } = point;
      let color;
      
      // Determine marker color based on status
      switch (point.status) {
        case 'pending':
          color = 'orange';
          break;
        case 'recogido':
          color = 'purple';
          break;
        case 'entregado':
          color = 'green';
          break;
        case 'cancelado':
          color = 'red';
          break;
        case 'encamino':
          color = 'blue';
          break;
        default:
          color = 'gray';
      }
      
      // Set default position if missing coordinates
      if (!latitude || !longitude) {
        const districtData = districts[point.district];
        if (districtData) {
          latitude = districtData.latitude + (Math.random() - 0.5) * 0.01;
          longitude = districtData.longitude + (Math.random() - 0.5) * 0.01;
        }
      }
      
      if (latitude && longitude) {
        // Create a custom icon for order marker using a square shape
        const icon = L.divIcon({
          html: `<div style="
            background-color: ${color};
            width: 20px;
            height: 20px;
            border: 1px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 8px;
            color: white;
            font-weight: bold;
          ">${point.sequence ? point.sequence : ''}</div>`,
          className: '',
          iconSize: [20, 20],
          iconAnchor: [10, 10],
        });
    
        const marker = L.marker([latitude, longitude], { icon, title: 'Order Location' })
          .on('click', () => {
            if (point.status === 'encamino') {
              setSelectedPoint(point);
            } else if (point.status === 'pending' && !point.customer_id) {
              handleSequenceChange(point);
            } else if (point.status === 'recogido') {
              setSelectedPoint(point);
            } else if (point.status === 'pending' && point.customer_id) {
              handleOrderSequenceChange(point);
            }
          })
          .addTo(mapRef.current);
    
        return marker;
      }
    });
    
    setOrderPointsMarkers(newMarkers);
  };

  const handleSequenceChange = async (point) => {
    const newSequence = prompt("Ingrese el nuevo número de secuencia:", point.sequence || 0);
    if (newSequence && !isNaN(newSequence)) {
      console.log('id ', point.id);
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/change/sequence`, {
          id: point.id,
          sequence: newSequence
        });
        
        
        if (response.status === 200) {
          setSequence(newSequence);  // Update local state
          alert('Secuencia actualizada exitosamente');
        } else {
          alert('Error al actualizar la secuencia');
        }
      } catch (error) {
        console.error('Error al actualizar la secuencia:', error);
        alert('Ocurrió un error al actualizar la secuencia');
      }
    } else {
      alert('Por favor, ingrese un número válido.');
    }
  };

  const handleOrderSequenceChange = async (point) => {
    const newSequence = prompt("Ingrese el nuevo númeroo de secuencia:", point.sequence || 0);
    if (newSequence && !isNaN(newSequence)) {
      console.log('id ', point.id);
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/change/order_sequence`, {
          id: point.id,
          sequence: newSequence
        });
        
        
        if (response.status === 200) {
          setSequence(newSequence);  // Update local state
          alert('Secuencia actualizada exitosamente');
        } else {
          alert('Error al actualizar la secuencia');
        }
      } catch (error) {
        console.error('Error al actualizar la secuencia:', error);
        alert('Ocurrió un error al actualizar la secuencia');
      }
    } else {
      alert('Por favor, ingrese un número válido.');
    }
  };


  const handleLogoClick = () => {
    setActiveComponent('Options')
  }

  const handleResumenClick = () => {
    setActiveComponent('ResumenDriver');
  };

  const handleClosePopup = () => {
    setSelectedPoint(null);
  };
  
  return (
    <div className="map">
      <div
        ref={mapContainerRef}
        style={{ width: "100%", height: "70vh" }}
      ></div>
      <div
        style={{
            position: "absolute",
            top: "25px",
            left: "25px",
            zIndex: 2000, // Ensure it stays on top
        }}
        onClick={handleLogoClick}
        >
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" style={{ height: "78px", width: "78px" }} />
        </div>

        <div
        style={{
          
          width: "75%",
          position: "absolute",
          top: "80px",
          left: "10px",
          zIndex: 2000, // Ensure it stays on top
      }}
        >
          </div>
          <div
        style={{
          width: "50%",
          position: "absolute",
          top: "80px",
          left: "10px",
          zIndex: 2000, // Ensure it stays on top
        }}
      >
        {selectedPoint && (
          <MarkerTextDriver point={selectedPoint} onClose={handleClosePopup} />
        )}
      </div>
      {/* <IconButton
        style={{
          position: "absolute",
          bottom: "72%",
          right: 30,
          zIndex: 1000,
          backgroundColor: "white",
          border: "2px solid black",
          borderRadius: "50%",
          color: "black",
          marginBottom: "10px",
          transform: "scale(0.9)",
        }}
        onClick={handleOrdersStartRoute}
      >
        <PlayCircleIcon />
      </IconButton> */}
      {/* <IconButton
        style={{
          position: "absolute",
          bottom: "66%",
          right: 30,
          zIndex: 1000,
          backgroundColor: "white",
          border: "2px solid black",
          borderRadius: "50%",
          color: "black",
          marginBottom: "10px",
          transform: "scale(0.9)",
        }}
        onClick={handleStartRoute}
      >
        <PlayArrowIcon />
      </IconButton> */}
          <IconButton
        style={{
          position: "absolute",
          bottom: "60%",
          right: 30,
          zIndex: 1000,
          backgroundColor: "white",
          border: "2px solid black",
          borderRadius: "50%",
          color: "black",
          marginBottom: "10px",
          transform: "scale(0.9)",
        }}
        onClick={handleResumenClick}
      >
        <MonetizationOnIcon />
      </IconButton>
      <IconButton
        style={{
          position: "absolute",
          bottom: "54%",
          right: 30,
          zIndex: 1000,
          backgroundColor: "white",
          border: "2px solid black",
          borderRadius: "50%",
          color: "black",
          marginBottom: "10px",
          transform: "scale(0.9)",
        }}
        onClick={handleRecojosClick}
      >
        <SupportAgentIcon />
      </IconButton>
          <IconButton
        style={{
          position: "absolute",
          bottom: "44%",
          right: 30,
          zIndex: 1000,
          backgroundColor: "white",
          border: "2px solid black",
          borderRadius: "80%",
          color: "black",
          marginBottom: "10px",
          transform: "scale(1.7)",
        }}
        onClick={handleEntregasClick}
      >
        <AddIcon />
      </IconButton>
      <div
              style={{
                height: "40vh",
                padding: "20px",
                backgroundColor: "#f7f7f7",
                overflowY: "auto",
              }}
            >
              {user && (
                    <MenuDriver user={user} userId={userId} deliveryPoints={deliveryPoints} setActiveComponent={setActiveComponent} orderPoints={orderPoints} onBackClick={onBackClick} setMainDeliveryPoints={setMainDeliveryPoints} setMainOrder={setMainOrder} />
                  )}

              
            </div>
        </div>
    
  );
}

export default MapDriver;
